import type { ProposalSavingsDto } from "~/api/dto/proposal.dto"

export type ProposalSavingsGate = `fetch` | `settle` | `wait`

export type ProposalSavingsGateInput = {
  requiresQuote: boolean
  hasMatchingUnpoisonedQuote: boolean
  quotesSyncWaiting: boolean
  quotesSnapshotSettled: boolean
  waitTimedOut: boolean
}

/** Max wait for a matching Quote before brochure savings settle empty. */
export const PROPOSAL_SAVINGS_QUOTE_WAIT_MS = 8_000

export const EMPTY_PROPOSAL_SAVINGS: ProposalSavingsDto = {
  netSavings: 0,
  lifetimeUtilityBillSavings: 0,
  costOfDoingNothing: 0,
  totalCost: 0,
  monthlyPayments: [0],
  monthlyPaymentsByYear: [0],
  paymentSource: `none`,
  solarRate: 0,
}

export type QuotesSnapshotQuote = {
  __typename?: string
  loanProductId?: string | null
}

export const shouldStampQuotesSnapshotSettled = (
  quotes: ReadonlyArray<QuotesSnapshotQuote>,
  selectedLoanProductId: string | null | undefined,
): boolean => {
  if (!selectedLoanProductId) return true

  return !quotes.some(
    (quote) =>
      quote.__typename === `Quote` &&
      quote.loanProductId != null &&
      quote.loanProductId !== selectedLoanProductId,
  )
}

export const getProposalSavingsGate = (
  input: ProposalSavingsGateInput,
): ProposalSavingsGate => {
  if (!input.requiresQuote) return `fetch`
  if (input.hasMatchingUnpoisonedQuote) return `fetch`
  if (input.waitTimedOut) return `settle`
  if (input.quotesSyncWaiting) return `wait`
  if (input.quotesSnapshotSettled) return `settle`

  return `wait`
}
